import { render, staticRenderFns } from "./FinalSlide.vue?vue&type=template&id=3bb9322e&scoped=true&lang=pug"
import script from "./FinalSlide.vue?vue&type=script&lang=ts"
export * from "./FinalSlide.vue?vue&type=script&lang=ts"
import style0 from "./FinalSlide.vue?vue&type=style&index=0&id=3bb9322e&prod&lang=scss"
import style1 from "./FinalSlide.vue?vue&type=style&index=1&id=3bb9322e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb9322e",
  null
  
)

export default component.exports